import { defineStore } from 'pinia'
import user from '@/data/user'

export const useIamServicesStore = defineStore('useIamServicesStore', {
  state: () => {
    return {
      services: [],
      options: {}
    }
  },

  actions: {
    setServicesToStore (services) {
      const options = {}
      /**
       * Удалить когда добавиться S3 сервис
       */
      services.push({
        name: 's3',
        description: 'S3 service (docs: https://doc.platformcraft.ru/filespot/api/#s3)',
        actions: [
          '*'
        ],
        resources: [
          '*'
        ]
      })

      services.forEach(s => {
        s.resources = s.resources.map(r =>
          r.replace(/{user_id}/g, user.user_id).replace(/{container_id}/g, user.user_id)
        ).sort((a, b) => a.length > b.length)

        options[s.name] = s
      })

      this.services = services
      this.options = options
    }
  }
})
